<template>
    <CModal
        title="Редактирование клиента"
        :show.sync="modal.visible"
        :footer="false"
        class="customer-item-edit   "
    >
        <template>
                <CForm>
                    <CRow
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Поиск клиента</CCol>
                        <CCol sm="9">
                            <template>
                                <Autocomplete
                                    ref="autocomplete"
                                    placeholder="Введите номер телефона или его часть"
                                    :search="getSustomers"
                                    :get-result-value="getResultValue"
                                    @submit="updateCustomer"
                                />
                            </template>
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.customer_id && modal.item.firstname"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Имя:</CCol>
                        <CCol 
                            sm="9"
                            class="col-form-label">
                            <span>{{ this.modal.item.firstname }}</span>
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.customer_id && modal.item.lastname"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Фамилия:</CCol>
                        <CCol 
                            sm="9"
                            class="col-form-label">
                            <span>{{ this.modal.item.lastname }}</span>
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.customer_id && modal.item.phone"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Телефон:</CCol>
                        <CCol 
                            sm="9" 
                            class="col-form-label">
                            <span>{{ this.modal.item.phone }}</span>
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.customer_id && modal.item.description"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Описание:</CCol>
                        <CCol 
                            sm="9" 
                            class="col-form-label">
                            <span>{{ this.modal.item.description }}</span>
                        </CCol>
                    </CRow>
                </CForm>
            <div slot="footer">
                <CButton
                    color="light"
                    class="ml-3"
                    @click="$emit('cancel')"
                >Отмена</CButton>
                <CButton
                    color="primary"
                    class="ml-3"
                    :disabled="!modal.item.customer_id"
                    @click="$emit('update')"
                >Сохранить</CButton>
            </div>
        </template>
    </CModal>
</template>

<script>
    import Vue from 'vue';
    const { formatDate } = require('../../utils/views');
    import Autocomplete from '@trevoreyre/autocomplete-vue';
    import '@trevoreyre/autocomplete-vue/dist/style.css';

    export default {
        name: 'CustomerEdit',

        components: {
            Autocomplete,
        },

        props: {
            modal: {
                type: Object,
                default: () => ({})
            }
        },

        data() {
            return {
                isAuthorized: false,
                order: {},
                customers: null,
            };
        },

        computed: {
            visible() {
                return this.modal.visible
            },
        },

        async mounted() {
            const orderId = parseInt(this.$route.params.id);
            try {
                const orderResp = await Vue.axios.get(`/orders/${orderId}`);
                this.order = JSON.parse(JSON.stringify(orderResp.data));
            } catch (err) {
                this.$root.$emit('showError', 'Ошибка при загрузке данных о заказе');
            }

            try {
                const customersResp = await Vue.axios.get('/customers');
                this.customers = customersResp.data;
            } catch (err) {
                this.$root.$emit('showError', 'Ошибка загрузки данных')
            }
        },

        methods: {
            async getSustomers(search) {
                return new Promise(resolve => {
                    if (search.length < 2) {
                        return resolve([]);
                    }

                    Vue.axios
                        .get(`/customers?search=${search}`, {})
                        .then(resp => {
                            resolve(resp.data.results);
                        })
                        .catch(err => {
                            console.log('Cannot load goods list.');
                        });
                });
            },

            getResultValue(result) {    
                return result.phone;
            },

            async updateCustomer(customer) {
                this.modal.item = {
                    ...JSON.parse(JSON.stringify(this.modal.emptyCustomer)),
                    ...{
                        customer: customer,
                        customer_id: customer.id,
                        firstname: customer.firstname,
                        lastname: customer.lastname,
                        phone: customer.phone,
                        description: customer.description,
                    }
                };
            },

        },
    };
</script>

<style lang="scss">
    .customer-item-edit {
        &__title {
            display: flex;
            align-items: center;
            width: 100%;
            height: calc(1.5em + 0.75rem + 2px);
        }
        .autocomplete-input {
            width: 100%;
            height: calc(1.5em + 0.75rem + 2px);
            border: 1px solid #d8dbe0;
            border-radius: 0.25rem;
            padding: 0.375rem 0.75rem 0.375rem 2rem;
            background-color: #fff;
            background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+);
            background-size: 0.875rem;
            background-position: left 0.75rem center;
            background-repeat: no-repeat;
            color: #768192;
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.5;
        }
        .autocomplete-result {
            cursor: default;
            padding: 0.375rem 0.75rem 0.375rem 2rem;
            background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjY2NjIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+);
            background-size: 15px;
            background-position: left 0.75rem center;
            background-repeat: no-repeat;
            color: #768192;
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.1;
        }
    }
</style>
